import { render } from "./ProfileCustomFields.vue?vue&type=template&id=c5c96106"
import script from "./ProfileCustomFields.vue?vue&type=script&lang=js"
export * from "./ProfileCustomFields.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__